import {
  doc,
  getDoc,
  collection,
  getFirestore,
  getDocs,
} from "@firebase/firestore";
import { authService } from "fbase";
import React, { useEffect, useState } from "react";
import QLog from "components/QLog";

const Profile = () => {
  /*const [docArr, setDocArr] = useState([]);
  // const [dataObj, setDataObj] = useState({});
  // const [timeObj, setTimeObj] = useState({});
  const [timeData, setTimeData] = useState({});
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  let newDocArr = [];
  const db = getFirestore();
  const userUID = authService.currentUser.uid;
  const colRef = collection(db, userUID);
  const GetLog = async () => {
    const colSnap = await getDocs(colRef);
    colSnap.forEach((doc) =>
      newDocArr.indexOf(doc.id) === -1
        ? (newDocArr = [...newDocArr, doc.id])
        : false
    );
    newDocArr = newDocArr.sort((a, b) => a - b);
    setDocArr(newDocArr);
  };
  useEffect(() => {
    GetLog();
  }, []);
  const GetQLog = (props) => {
    const GetTimeLog = async (id) => {
      let docRef;
      console.log(id);
      if (id.length !== 11) return;
      else docRef = doc(db, id.slice(0, 4), id.slice(-6));

      const docSnap = await getDoc(docRef);
      let data = docSnap.data();
      let newDataArr = [];
      if (data) {
        newDataArr = Object.values(data);
        newDataArr.splice(newDataArr.indexOf("answer"), 1);

        newDataArr = newDataArr.sort((a, b) => a - b);
        // let newTimeObj = timeObj;
        // let newDataObj = dataObj;
        let newTimeData = timeData;
        // newTimeObj[id] = data[userUID] / 1000;
        // newDataObj[id] = newDataArr;
        newTimeData[id] = {};
        newTimeData[id]["imgLink"] =
          "https://storage.googleapis.com/pacemaker_storage/%E1%84%80%E1%85%AA%E1%84%90%E1%85%A1%E1%86%B7%E1%84%80%E1%85%B5%E1%84%8E%E1%85%AE%E1%86%AF/" +
          id.slice(0, 4) +
          "/img/" +
          id.slice(5, 7) +
          "/" +
          id.slice(7, 9) +
          "/" +
          id.slice(-6) +
          ".jpg";
        newTimeData[id]["time"] = data[userUID] / 1000;
        newTimeData[id]["data"] = newDataArr;
        // setTimeObj(newTimeObj);
        // setDataObj(newDataObj);
        setTimeData(newTimeData);
      }
    };
    useEffect(() => {
      docArr.map((id) => GetTimeLog(id));
    }, [docArr]);

    return <div>{QLog(timeData)}</div>;
    // return(QLog('210602', dataObj, timeObj))
  };
  return (
    <div
      style={{
        height: `${windowHeight * 0.89}px`,
        width: `${windowWidth * 0.95}px`,
        backgroundColor: "gray",
        overflow: "scroll",
      }}
    >
      <div>{<GetQLog docArr={docArr} />}</div>
    </div>
  );*/
  return (
    <div>
      <p>지원 예정입니다.</p>
      <p>1. 오답노트</p>
      <p>2. 풀이 문항별 내 백분위</p>
      <p>3. 유형별 내 백분위</p>
      <p>
        4. 추가 요청사항은{" "}
        <a href="https://open.kakao.com/o/s3gKxO2b">카카오톡</a>으로 보내주세요
      </p>
    </div>
  );
};

export default Profile;
